<template>
  <div class="cb" v-if="kbxmlc">
    <div :class="['box', kbxmlc.zt == '2' || role != 'Z' ? 'noBtn' : '']">
      <div class="clear">
        <p class="cont-title lf">唱标</p>
        <div class="rt">
          <el-button
            type="primary"
            style="float: left;"
            @click="refresh"
            v-if="sfchjy"
            >刷新</el-button
          >
          <el-input
            v-model="tbdwmc"
            class="input-with-select lf"
            style="width: 250px; margin: 0 10px"
            placeholder="投标单位名称"
            clearable
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getData"
            ></el-button>
          </el-input>
          <template v-if="role == 'Z'">
            <el-button
              type="primary"
              @click="setCs"
              v-if="
                sfycs && isOpenKbcs
              "
              >{{ showGz ? "抽签参数" : "参数设置" }}</el-button
            >

            <!-- 1713工程开标新增抽签 -->
            <template 
              v-if="kbxm.fcpbbflxm == 'D82EC4A199DB4A08A2F9217CC2C3822A'"
            >
              <drawRecord ref="recordDialog" :djlcId="djlcId" :kbxm="kbxm" />
              <el-button style="margin-left: 10px;" type="primary" @click="handleRecord">抽签记录</el-button>
            </template>

            <el-button type="primary" @click="lookRules" v-if="showGz"
              >查看抽取规则</el-button
            >
            <el-button type="primary" @click="cb" :disabled="kbxmlc.zt == '2'"
              >电声唱标</el-button
            >
            <el-button @click="handlePause" type="primary" v-if="isStart">
              <template v-if="isStop">继续</template>
              <template v-else>暂停</template>
            </el-button>
          </template>
        </div>
      </div>
      <p
        class="red"
        style="padding-bottom: 10px"
        v-if="sfycs"
      >
        <span v-if="newTips">
          {{ newTips }}
        </span>
        <span v-else>
          <template v-if="!csjg || csjg.length == 0">
            {{ role == "Z" ? "请按招标文件要求设置参数" : "请等待设置参数" }}
          </template>
          <template v-else>
            <template v-for="(item, index) in csjg"
              >{{ item.prefix }} : {{ item.val }}{{ item.suffix
              }}{{ index == csjg.length - 1 ? " 。" : " ," }}</template
            >
          </template>
        </span>
      </p>

      <!-- 唱标表格 -->
      <cbTable 
        v-loading="waitLoading"
        :tableHead="tableHead" 
        :tableData="tableData" 
        :dcbjHead="dcbjHead" 
        :role="role" 
        :publishType="ispublishAll"
      />

      <div class="clear">
        <span class="lf pageNum">共{{ total }}家。</span>
      </div>
    </div>
    <el-button
      type="primary lcNext"
      @click="nextBtn"
      v-if="kbxmlc.zt != '2' && role == 'Z'"
      :disabled="waitLoading"
      >下一步</el-button
    >
    <!-- 设置参数 -->
    <el-dialog
      title="设置参数"
      :visible.sync="dialogFormVisible"
      width="auto"
      :close-on-click-modal="false"
    >
      <el-form :model="form" ref="form" label-position="left">
        <el-form-item
          :label="item.csmc"
          v-for="(item, index) in formItem"
          :key="index"
          :prop="item.csdm"
          :rules="setFormItemRules(item)"
        >
          <template v-if="objectType == 1">
            <!-- 玉环D值单独判断逻辑 -->
            <el-select
              v-if="item.csdm == 'valueDtype'"
              v-model="form[item.csdm]"
              placeholder="请先选择"
              @focus="selectFocus"
              style="width: 305px"
            >
              <el-option
                v-for="item in dOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
            <!-- 玉环D值单独判断逻辑 end -->

            <!-- 抽取下浮率(%):单独判断 -->
            <div v-if="item.csdm == 'cqxfl'">
              <template>
                <el-input
                  v-for="index in 3"
                  :key="index"
                  v-model="form[item.csdm + index]"
                  oninput="value=value.replace(/[^\d\.\-0]/g,'').replace(/^\./g, '')"
                  style="width: 25%; margin-right: 8px"
                  @input="handleCqxfl(item.csdm)"
                >
                </el-input>
              </template>
            </div>
            <el-input
              v-else
              oninput="value=value.replace(/[^\d\.\-0]/g,'').replace(/^\./g, '')"
              :disabled="!item.canEdit"
              v-model="form[item.csdm]"
              :style="
                item.csdm == 'zgtbxjkpyt' ? 'width: 230px' : 'width: 200px'
              "
            ></el-input>
          </template>
          <template v-else>
            <el-select
              v-if="item.csdm == 'valueDtype'"
              v-model="form[item.csdm]"
              placeholder="请先选择"
              @focus="selectFocus"
              style="width: 305px"
            >
              <el-option
                v-for="item in dOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
            <el-input
              v-model="form[item.csdm]"
              :disabled="item.abled"
              @input="defaultValue(item.csdm, form[item.csdm], item.ball)"
              :style="
                item.csdm == 'zgtbxjkpyt' ? 'width: 230px' : 'width: 200px'
              "
            ></el-input>
          </template>
          {{ item.cshz }}
          <el-button
            type="primary"
            v-if="showGz && item.csdm == 'valueDtype'"
            @click="goLink"
            >进入抽签系统</el-button
          >
          <el-button
            type="primary"
            v-if="showGz && item.extracted"
            @click="goLinkNew"
            >进入抽签系统</el-button
          >

          <!-- 1713工程开标新增抽签 -->
          <el-button
            type="primary"
            v-if="item.csdm == 'zjbjstring' && kbxm.fcpbbflxm == 'D82EC4A199DB4A08A2F9217CC2C3822A'"
            style="margin-left: 10px;"
            @click="goLinkGc"
          >进入抽签系统</el-button>
        </el-form-item>
      </el-form>
      <el-button
        type="primary"
        class="link"
        style="right: 130px"
        v-if="kbxm.fcpbbflxm == '9950EC15AF2244329F799BB1E7CD0696'"
        @click="goCustomLink"
        >进入抽签系统</el-button
      >
      <div class="btnBox">
        <el-button
          type="primary"
          @click="saveForm('form')"
          :disabled="waitLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 电声唱标 -->
    <el-dialog
      title="电声唱标"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form :model="dsForm" label-width="70px">
        <el-form-item label="音量">
          <el-radio-group v-model="dsForm.volume">
            <el-radio :label="0.2">低</el-radio>
            <el-radio :label="0.4">中</el-radio>
            <el-radio :label="0.6">高</el-radio>
            <el-radio :label="0.8">很高</el-radio>
            <el-radio :label="1">最高</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="语速">
          <el-radio-group v-model="dsForm.rate">
            <el-radio :label="0.75">0.75x</el-radio>
            <el-radio :label="1">1.0X</el-radio>
            <el-radio :label="1.25">1.25X</el-radio>
            <el-radio :label="1.5">1.5X</el-radio>
            <el-radio :label="2">2.0X</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="btnBox">
        <el-button type="primary" @click="handleSpeak">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="抽取规则"
      :visible.sync="showRules"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="rules">
        <p v-for="(item, index) in rules" :key="index">{{ item }}</p>
      </div>
      <div class="btnBox">
        <el-button type="primary" @click="showRules = false">确定</el-button>
      </div>
    </el-dialog>
    <lht-mark
      v-if="lhtVisible"
      :visible.sync="lhtVisible"
      :lhtId="lhtId"
    ></lht-mark>
  </div>
  <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>
<script>
import lhtMark from "@/components/lhtMark/index.vue";
import drawRecord from "./components/drawRecord.vue";
import cbTable from "./components/cbTable.vue";

export default {
  name: "cb",
  components: { lhtMark, drawRecord, cbTable },
  data() {
    return {
      waitLoading: false,
      kbxmlc: "",
      djlcId: "", // 当前节点状态
      sfycs: true,
      tableHead: {},
      tableData: [],
      tbdwmc: "",
      multipleSelection: [], // 表格选择
      isOk: false, // 是否可以下一步
      csjg: [], // 是否已经设置过参数
      dialogFormVisible: false, //设置参数
      formItem: [],
      form: {},
      dialogVisible: false, //电声唱标
      dsForm: {
        volume: 1,
        rate: 1,
      },
      synth: "", //对象
      msg: "", //实例
      isStop: false, //是否暂停电声状态
      isStart: false,
      text: [], //电声内容
      num: 0,
      role: localStorage.getItem("role") ? localStorage.getItem("role") : "T",
      ispublishAll: "",
      dcbjHead: [],
      objectType: "", //项目大类1、采购项目 2、工程项目
      setCsdm: "",
      setCqs: "",
      setBall: "",
      // validateFrom: {},
      showGz: false,
      showRules: false,
      rules: [],
      newTips: null,
      dOptions: [],
      kbxm: {},
      isOpenKbcs: true,
      lhtVisible: false,
      lhtId: "",
      timer: null,
      sfchjy: false, // 长湖监狱
    };
  },
  computed: {
    // 是否多次报价项目
    isDcbj() {
      return [1, 2, 3].includes(this.ispublishAll)
    }
  },
  methods: {
    handleCqxfl(csdm) {
      console.log(csdm, ";21321");
      if (this.form[csdm + 1] && this.form[csdm + 2] && this.form[csdm + 3]) {
        this.form.xfl = (
          (Number(this.form[csdm + 1]) +
            Number(this.form[csdm + 2]) +
            Number(this.form[csdm + 3])) /
          3
        ).toFixed(2);
        this.form.cqxfl =
          this.form[csdm + 1] +
          "," +
          this.form[csdm + 2] +
          "," +
          this.form[csdm + 3];
      }
    },
    openLht(id) {
      this.lhtVisible = true;
      this.lhtId = id;
    },
    selectFocus() {
      try {
        this.$api.getValueDTypes().then((res) => {
          if (res.status == 200) {
            this.dOptions = res.data.data;
          }
        });
      } catch (error) {
        this.$message.warning("获取d值失败");
      }
    },
    goCustomLink() {
      // 打开新标签 并且监听新标签抽中的参数
      let _this = this;
      let url = "/draw?dData=" + this.form.valueDtype;
      window.open(url, "_blank");
      window.addEventListener("storage", function (event) {
        if (event.key === "myParam" && event.newValue !== null) {
          // 从新标签页传递回来的参数
          const param = JSON.parse(event.newValue);
          if (param.result.length > 0) {
            let num;
            let str = "";
            param.result.length > 1
              ? (num = param.result[0].jg + "." + param.result[1].jg)
              : (num = param.result[0].jg);
            _this.formItem.forEach((el) => {
              if (el.csmc == "D值：") {
                str = el.csdm;
              }
            });
            _this.$set(_this.form, str, num);
          }
        }
      });
    },
    /**
     * 设置表单校验规则
     * @param formItem
     */
    setFormItemRules(formItem) {
      // 预设x、y值的校验函数
      let validatorObj = {
        x: (rule, value, callback) => {
          if (!/^[0-9]$/.test(value)) {
            return callback(new Error("x值的取值范围为0-9的整数"));
          } else {
            callback();
          }
        },
        y: (rule, value, callback) => {
          if (!/^[0-9]$/.test(value)) {
            return callback(new Error("y值的取值范围为0-9的整数"));
          } else {
            callback();
          }
        },
      };
      // 预设x、y值的校验规则
      let ruleX = [{ validator: validatorObj.x, trigger: "change" }];
      let ruleY = [{ validator: validatorObj.y, trigger: "change" }];

      let rules = /^[a-z]$/g.test(formItem.csdm)
        ? [{ validator: this.validateFieldMethods, trigger: "blur" }]
        : formItem.csdm == "cqxfl"
        ? []
        : formItem.urldz == 1
        ? [] 
        : [{ required: true, message: "必填项", trigger: "blur" }];
      // x值
      if (formItem.csdm === "xkpyt") {
        rules = rules.concat(ruleX);
      }
      // y值
      if (formItem.csdm === "ykpyt") {
        rules = rules.concat(ruleY);
      }
      return rules;
    },
    goLink() {
      // 打开新标签 并且监听新标签抽中的参数
      let _this = this;
      if (this.form.valueDtype) {
        let url = "/draw?dData=" + this.form.valueDtype;
        window.open(url, "_blank");
        window.addEventListener("storage", function (event) {
          if (event.key === "myParam" && event.newValue !== null) {
            // 从新标签页传递回来的参数
            const param = JSON.parse(event.newValue);
            if (param.result.length > 0) {
              let num = 0;
              _this.formItem.forEach((el, index) => {
                if (el.csdm !== "valueDtype") {
                  _this.$set(_this.form, el.csdm, param.result[num]?.jg);
                  num++;
                }
              });
            }
          }
        });
      } else {
        this.$message.warning("请先选择D值");
      }
    },
    goLinkNew() {
      // 打开新标签 并且监听新标签抽中的参数
      console.log(this.formItem);
      let _this = this;
      let url = "/cqxflDraw";
      window.open(url, "_blank");
      window.addEventListener("storage", function (event) {
        if (event.key === "myParam" && event.newValue !== null) {
          console.log("------", event.newValue);
          // 从新标签页传递回来的参数
          const param = JSON.parse(event.newValue);
          if (param.result.length > 0) {
            const str = _this.formItem.find((item) => item.extracted);
            for (let i = 1; i < 4; i++) {
              _this.$set(_this.form, [str.csdm + i], param.result[0].jg[i - 1]);
            }
            _this.handleCqxfl(str.csdm);
          }
        }
      });
    },

    // 1713工程开标新增抽签
    goLinkGc() {
      // 打开新标签 并且监听新标签抽中的参数
      let _this = this;
      let url = `/gcDraw?kbxmId=${this.kbxmlc.kbxmId}&lcId=${this.djlcId}`;
      window.open(url, "_blank");
      window.addEventListener("storage", function (event) {
        if (event.key === "myParam" && event.newValue !== null) {
          // 从新标签页传递回来的参数
          console.log("抽签结果返回数据：", event.newValue);
          const param = JSON.parse(event.newValue);
          if (param.result.length > 0) {
            _this.$set(_this.form, 'zjbjstring', param.result[0].jg);
          }
        }
      });
    },

    //开评一体
    async lookRules() {
      let para = { kbxmId: this.kbxmlc.kbxmId };
      try {
        let res = await this.$api.getPbbfcsByKbxmId(para);
        if (res.status == 200) {
          this.rules = res.data.data;
          this.showRules = true;
        } else {
          this.$message({ type: "error", message: res.message });
        }
      } catch (err) {
        console.log(err);
      }
    },
    // ------------2021-10-26新增
    async publish() {
      let para = {
        djlcId: this.djlcId,
        tbdwmc: this.tbdwmc,
      };
      try {
        let res = await this.$api.isInit(para);
        if (res.status == 200) {
          this.isOpenKbcs = res.data.data.isOpenKbcs;
          this.ispublishAll = res.data.data.isPublish;
          this.csjg = res.data.data.csList;
          res.data.data.dcbj?.forEach((ele, index) => {
            this.dcbjHead = [...ele.cgkbdcbjList];
          });
          this.total = res.data.data.total;
          this.kbxmlc = res.data.data.kbxmlc;
          this.tableHead = res.data.data.bjxsmc;
          this.tableData = res.data.data.dcbj?.map(item => {
            item.cgkbdcbjqtcbList.forEach(sub => {
              item[sub.sxdm] = sub.srz
            })
            return item;
          });
          console.log(this.tableHead)
          console.log(this.tableData)
        } else {
          this.$message({ type: "error", message: res.message });
        }
      } catch (err) {
        console.log("投标人", err);
      }
    },
    // ---------------
    changeInp(name) {
      this.form[name] = this.form[name].replace(/[^\d.]/g, ""); //清除非 数字和小数点的字符
      this.form[name] = this.form[name].replace(/\.{2,}/g, "."); //清除第二个小数点
      this.form[name] = this.form[name].replace(/^\./g, ""); //验证第一个字符是数字而不是字符
      this.form[name] = this.form[name]
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      this.form[name] = this.form[name].replace(
        /^(\-)*(\d+)\.(\d\d).*$/,
        "$1$2.$3"
      ); //保留两位小数
      this.form[name] =
        this.form[name].indexOf(".") > 0
          ? this.form[name].split(".")[0].substring(0, 5) +
            "." +
            this.form[name].split(".")[1]
          : this.form[name].substring(0, 5); //限制只能输入7位正整数
    },
    async getCbData() {
      let para = {
        tbdwmc: this.tbdwmc,
        djlcId: this.djlcId,
      };
      this.waitLoading = true;
      const res = await this.$api.getCbData(para);
      if (res.data.meta.success) {
        this.kbxmlc = res.data.data.kbxmlc;
        this.total = res.data.data.data.total;
        this.csjg = res.data.data.csList;
        this.sfycs = res.data.data.sfycs;
        this.kbxm = res.data.data.kbxm;
        this.newTips = res.data.data.cscqStr; // 张焱新增字段 2021/12/15
        this.showGz = res.data.data.showGz; //是否开评一体展示规则按钮
        this.sfchjy = res.data.data.sfchjy;
        if (!this.isDcbj) {
          // 非多次报价项目构造表格数据
          this.tableHead = res.data.data.bjxsmc;
          if (res.data.data.tbdwMap) {
            var arr = res.data.data.data.tbdwList;
            arr.forEach((item, index) => {
              for (let key in res.data.data.tbdwMap[item.id]) {
                item[key] = res.data.data.tbdwMap[item.id][key];
              }
            });
            this.tableData = arr;
          } else {
            this.tableData = res.data.data.data.tbdwList;
          }
        }

        if (!("speechSynthesis" in window)) {
          if (this.kbxmlc.zt != "2") {
            this.$message({
              type: "error",
              message:
                "对不起，您的浏览器不支持电声唱标，请更换急速模式或者谷歌浏览器",
            });
          }
        } else {
          this.msg = null;
          this.synth = window.speechSynthesis;
          this.synth.speak(new SpeechSynthesisUtterance(""));
          this.init();
        }
        this.waitLoading = false;
      } else {
        this.waitLoading = false;
        this.$message({
          type: "error",
          message: res.data.meta.message,
        });
      }
    },
    //设置参数
    setCs() {
      let para = {};
      this.waitLoading = true;
      this.$api
        .getKbxmCscqnrForm(para)
        .then((res) => {
          this.waitLoading = false;
          if (res.data.meta.success) {
            if (res.data.data.kcList.length) {
              this.formItem = res.data.data.kcList;
              this.formItem.forEach((item) => {
                let reg = /^[a-z][z]$/g;
                let reg2 = /^[a-z]$/g;
                if (reg.test(item.csdm)) {
                  item.abled = true;
                } else {
                  item.abled = false;
                }
                if (reg2.test(item.csdm)) {
                  item.ball = 1; // 是选球
                } else {
                  item.ball = 0; // 不是选球
                }
              });
              if (res.data.data.csMap) {
                this.form = Object.assign({}, res.data.data.csMap);
                if (res.data.data.csMap.cqxfl) {
                  let arr = res.data.data.csMap.cqxfl.split(",");
                  arr.forEach((el, index) => {
                    this.$set(this.form, "cqxfl" + (index + 1), el);
                    this.form["cqxfl" + (index + 1)] = el;
                  });
                }
              }
              this.dialogFormVisible = true;
            } else {
              this.$message({
                type: "warning",
                message: "无需设置参数",
              });
            }
          }
        })
        .catch(() => {});
    },
    defaultValue(csdm, cqs, ball) {
      this.form[csdm] = this.form[csdm]
        .replace(/[^\d\.\-0]/g, "")
        .replace(/^\./g, "");
      this.setCsdm = csdm;
      this.setCqs = cqs;
      this.setBall = ball;
      // this.validateFrom[csdm] == "";
    },
    changeBallNum(csdm, cqs, ball) {
      // this.waitLoading = true;
      if (ball != 1) return;
      let para = {
        csdm,
        cqs,
      };
      return this.$api
        .hqcqz(para)
        .then((res) => {
          // this.waitLoading = false;
          if (res.data.data == 999) {
            this.form[csdm] = "";
            return 1;
          }
          this.form[csdm + "z"] = res.data.data;
          return 0;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async validateFieldMethods(rule, value, callback) {
      if (!value) {
        callback(new Error("必填项"));
      } else {
        // if (this.validateFrom[this.setCsdm] == 0) {
        //   callback();
        // } else {
        let text = await this.changeBallNum(
          this.setCsdm,
          this.setCqs,
          this.setBall
        );
        if (text == 1) {
          callback(new Error("请输入正确的球号！"));
        } else {
          // this.validateFrom[this.setCsdm] = text;
          callback();
          // }
        }
      }
    },
    //保存参数设置
    saveForm(formName) {
      this.$refs[formName].validate((valide) => {
        if (valide) {
          this.waitLoading = true;
          this.dialogFormVisible = false;
          let para = this.form;
          this.$api
            .saveSzcs(para)
            .then((res) => {
              if (res.data.meta.success) {
                this.getData();
                this.csjg = [];
                this.formItem.forEach((a) => {
                  if (this.form[a.csdm]) {
                    let obj = {
                      prefix: a.csmc,
                      val: this.form[a.csdm],
                      suffix: a.cshz,
                    };
                    this.csjg.push(obj);
                  }
                });
                let obj = {
                  lx: "zb",
                  data: {
                    id: "",
                  },
                };
                this.$emit("send", JSON.stringify(obj));
                this.waitLoading = false;
                // 清除设置参数的监听
                window.removeEventListener("storage");
              } else {
                this.$message({
                  type: "error",
                  message: res.data.meta.message,
                });
                this.waitLoading = false;
              }
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    //查看投标单位多清单
    lookXq(row) {},
    //电声唱标
    cb() {
      if (!("speechSynthesis" in window)) {
        this.$message({
          type: "error",
          message:
            "对不起，您的浏览器不支持此功能，请更换急速模式或者谷歌浏览器",
        });
      } else {
        this.dialogVisible = true;
        var arr = [];
        this.text = [];
        if (this.multipleSelection.length) {
          arr = this.multipleSelection;
        } else {
          arr = this.tableData;
        }
        arr.forEach((item, index) => {
          var text = item.fcqymc + ",";
          for (let key in this.tableHead) {
            text += item[this.tableHead[key]] + ",";
          }
          this.text[index] = text + " ," + text + " ," + text;
        });
      }
    },
    //多选表格
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    nextBtn() {
      if (
        this.csjg.length == 0 &&
        this.sfycs &&
        this.isOpenKbcs
      ) {
        if (!this.newTips) {
          if (this.showGz) {
            this.$message.error("请设置参数！");
          } else {
            this.$confirm(
              "您还未设置参数，请确认该项目无参数需要设置！",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(() => {
                let para = {
                  flag: this.kbxmlc.ycdz,
                };
                this.waitLoading = true;
                this.$emit("nextBtn", para);
              })
              .catch(() => {});
          }
        } else {
          let para = {
            flag: this.kbxmlc.ycdz,
          };
          this.waitLoading = true;
          this.$emit("nextBtn", para);
        }
      } else if (this.isStart) {
        this.$confirm("请确认是否结束电声唱标，并进入下一步！", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let para = {
              flag: this.kbxmlc.ycdz,
            };
            this.waitLoading = true;
            this.$emit("nextBtn", para);
          })
          .catch(() => {});
      } else {
        let para = {
          flag: this.kbxmlc.ycdz,
        };
        this.waitLoading = true;
        this.$emit("nextBtn", para);
      }
    },
    handleSpeak() {
      /* if(!this.msg){
                return
            } */
      this.msg.text = this.text[this.num]; //文本
      this.msg.lang = "EN";
      this.msg.volume = this.dsForm.volume; //声音的音量，区间范围是0到1，默认是1
      this.msg.rate = this.dsForm.rate; //语速
      this.msg.pitch = 1; //音调高低
      this.synth.speak(this.msg);
      this.dialogVisible = false;
      if (this.multipleSelection.length) {
        this.$refs.table.setCurrentRow(this.multipleSelection[this.num]);
      } else {
        this.$refs.table.setCurrentRow(this.tableData[this.num]);
      }
    },
    // 语音暂停
    handlePause() {
      if (this.isStop) {
        this.isStop = false;
        this.synth.resume();
      } else {
        //暂停
        this.synth.pause();
        this.isStop = true;
      }
      //停止
      //window.speechSynthesis.cancel();
    },

    init() {
      this.msg = new SpeechSynthesisUtterance();
      let _this = this;
      this.msg.onend = function () {
        //唱完了
        if (_this.num == _this.text.length - 1) {
          _this.synth.cancel(_this.msg);
          _this.num = 0;
          _this.$refs.table.setCurrentRow();
        } else {
          _this.num++;
          _this.handleSpeak();
        }
        _this.isStart = false;
      };
      this.msg.onstart = function () {
        _this.isStart = true;
      };
    },
    
    getFileType() {
      return this.$api
        .judgeType()
        .then((res) => {
          return res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    handleRecord() {
      this.$refs.recordDialog.show()
    },

    // 加载唱标表格数据
    async getData() {
      this.waitLoading = true;
      let type = await this.getFileType();
      this.objectType = type;
      //项目大类1、采购项目 2、工程项目
      if (type == "1") {
        // 还得区分是否是多次报价的项目
        await this.publish();
        this.waitLoading = false;
      }
      await this.getCbData();
    },
    refresh() {
      this.getData();
    },
  },

  async created() {
    this.djlcId = this.$route.query.djlcId;
    await this.getData();
    if (this.sfchjy) {
      this.timer = setInterval(() => {
        this.refresh();
      }, 15000);
    }
  },
  beforeDestroy() {
    if ("speechSynthesis" in window) {
      this.msg = null;
      this.synth.cancel(this.msg);
    }
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
};
</script>
<style lang="less" scoped>
::v-deep .el-dialog__body {
  padding: 20px 60px;
}
::v-deep .el-form-item__content {
  display: flex;
}

.link {
  top: 138px;
  position: absolute;
  right: 170px;
  font-size: 12px;
  cursor: pointer;
}
.cb {
  .cont-title {
    span {
      font-size: 14px;
      font-weight: normal;
      margin-left: 5px;
    }
  }
  .rules {
    p {
      line-height: 24px;
      margin-bottom: 10px;
    }
    margin-bottom: 30px;
  }
}
</style>
